// extracted by mini-css-extract-plugin
export default {"customScroll":"EventPopup_customScroll__iGDJe"};